var _style, _path, _path2, _path3, _path4, _path5, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#165366;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#0000AE;}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.9,37.3H115.1c-43,0-77.8,34.9-77.8,77.8v129.7c0,43,34.9,76,77.8,76h129.7c43,0,77.8-33,77.8-76V115.1 C322.7,72.1,287.9,37.3,244.9,37.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.837,
    y1: 263.2325,
    x2: 324.1631,
    y2: 96.7674
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00273C",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    style: {
      stopColor: "#165366",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.9,37.3H115.1c-43,0-77.8,34.9-77.8,77.8v129.7c0,43,34.9,77.8,77.8,77.8h129.7c43,0,77.8-34.9,77.8-77.8 V115.1C322.7,72.1,287.9,37.3,244.9,37.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M244.9,37.3L244.9,37.3c-114.6,0-207.6,92.9-207.6,207.6v0c0,43,34.9,77.8,77.8,77.8h129.7 c43,0,77.8-34.9,77.8-77.8V115.1C322.7,72.1,287.9,37.3,244.9,37.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.7032,
    y1: 283.7854,
    x2: 336.0292,
    y2: 117.3203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00897C",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4501,
    style: {
      stopColor: "#00897C",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M244.9,37.3L244.9,37.3c-114.6,0-207.6,92.9-207.6,207.6v0c0,43,34.9,77.8,77.8,77.8h129.7 c43,0,77.8-34.9,77.8-77.8V115.1C322.7,72.1,287.9,37.3,244.9,37.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.0292,
    y1: 117.3203,
    x2: 47.7032,
    y2: 283.7854
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FE7DE",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5043,
    style: {
      stopColor: "#0000AE",
      stopOpacity: 0
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M244.9,37.3L244.9,37.3c-114.6,0-207.6,92.9-207.6,207.6v0c0,43,34.9,77.8,77.8,77.8h129.7 c43,0,77.8-34.9,77.8-77.8V115.1C322.7,72.1,287.9,37.3,244.9,37.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 180,
    cy: 180,
    r: 85.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 180,
    cy: 180,
    r: 28.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoo);
export default __webpack_public_path__ + "static/media/zoo.efbd4a7a5a26912f08a2c0f0c278743e.svg";
export { ForwardRef as ReactComponent };